import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { EnumErrorStates, ErrorObject } from '@inmoment/the-kitchen';

import { AnalysisGroup } from 'app/providers/storage-api/analysis-group-service';
import { Project } from 'app/providers/storage-api/project.service';
import { generalNameValidator } from 'app/utils/customValidators';

@Component({
  selector: 'app-rename-analysis-group',
  templateUrl: './rename-analysis-group.component.html',
  styleUrls: ['./rename-analysis-group.component.scss'],
  standalone: false,
})
export class RenameAnalysisGroupComponent implements OnInit {
  @Input() analysisGroup: AnalysisGroup;
  @Input() project: Project;

  @Output() modalClosed: EventEmitter<any> = new EventEmitter();

  displayName: string;
  groupNameStatus: ErrorObject = { state: EnumErrorStates.SUCCESS, text: '' };

  ngOnInit() {
    this.displayName = this.analysisGroup.name;
  }

  onValidateAnalysisGroupName() {
    let exsistingNames: string[] = [];

    exsistingNames = this.project.groups.reduce((names: string[], group) => {
      if (group.id !== this.analysisGroup.id) {
        names.push(group.name);
      }

      return names;
    }, []);

    generalNameValidator(
      this.displayName,
      this.groupNameStatus,
      translate('rename-analysis-group.analysis-group'),
      64,
      true,
      exsistingNames,
      false
    );
  }

  analysisGroupNameHasErrors(): boolean {
    return (
      this.groupNameStatus.state !== EnumErrorStates.SUCCESS ||
      this.displayName.trim() === this.analysisGroup.name
    );
  }

  cancel() {
    this.modalClosed.emit(null);
  }

  saveGroupName() {
    const groupData = this.analysisGroup;
    this.displayName = this.displayName.trim();
    groupData.name = this.displayName;
    this.modalClosed.emit(groupData);
  }
}
